<template>
    <v-container style="max-width: 95%;">
            <v-row class="pt-6">
                <v-col cols="2" class="py-0">
                    <v-btn icon class="text--white80 px-6 pb-1" @click="goBack">
                        <v-icon large left class="text--white80">mdi-arrow-u-left-top</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="8" class="py-0">
                    <h3 class="text--white80 text-center">{{ sensorName }} LOG</h3>
                </v-col>
            </v-row>
        <v-timeline dense
                    clipped
                    :class="{ 'transparent-line': logItems.length <= 1 }"
                    class="pt-5">
            <v-timeline-item v-for="item in logItems" :key="item.id" color="white" large>
                <template v-slot:icon>
                    <v-avatar>
                        <img src="@/assets/icons/door-opened.svg" v-if="item.latestEventName === 'Door opened'" />
                        <img src="@/assets/icons/door-closed.svg" v-else-if="item.latestEventName === 'Door closed'" />
                        <img src="@/assets/icons/paired.svg" v-else-if="item.latestEventName === 'Device paired successfully'" />
                        <img src="@/assets/icons/switched-on.svg" v-else-if="item.latestEventName === 'Device ON'" />
                        <img src="@/assets/icons/switched-off.svg" v-else-if="item.latestEventName === 'Device OFF'" />
                        <img src="@/assets/icons/bilge-pump-on.svg" v-else-if="item.latestEventName === 'Bilge pump ON'" />
                        <img src="@/assets/icons/bilge-pump-off.svg" v-else-if="item.latestEventName === 'Bilge pump OFF'" />                        <img src="@/assets/icons/wired-disconnected.svg" v-else-if="item.latestEventName === 'Sensor unplugged'" />
                        <img src="@/assets/icons/wired-connected.svg" v-else-if="item.latestEventName === 'Sensor plugged in'" />
                        <img src="@/assets/icons/sirene-red.svg" v-else-if="item.latestEventName.startsWith('Alarm')" />
                        <img src="@/assets/icons/warning-red.svg" v-else-if="item.latestEventName === 'Disconnected'" />
                        <img src="@/assets/icons/unresponsive.svg" v-else-if="item.latestEventName === 'Unresponsive'" />
                        <img src="@/assets/icons/responsive.svg" v-else-if="item.latestEventName === 'Responsive'" />
                        <img src="@/assets/icons/unknown-error.svg" v-else-if="item.latestEventName === 'Unknown event'" />
                        <img src="@/assets/icons/unknown-error.svg" v-else />
                    </v-avatar>
                </template>
                <v-row justify="space-between" align="center" pt-2>
                    <v-col cols="5" class="white--text">{{ item.latestEventName }}</v-col>
                    <v-col cols="7" class="text-right white--text pr-6">{{ formatModifiedDate(item.modifiedDate) }}</v-col>
                </v-row>
            </v-timeline-item>
        </v-timeline>
    </v-container>
</template>
<script lang="ts">
    import {
        ref,
        getCurrentInstance,
        defineComponent
    } from "vue";
    import useSensorHistory from "@/store/useSensorHistory";
    import useDevice from "@/utilities/useDevice";
    import moment from 'moment-timezone';
    import useUserSettings from "@/store/useUserSettings";
    import UserSettingsViewModel from "@/models/UserSettingsViewModel";

    export default defineComponent({
        setup() {
            const root = getCurrentInstance()?.proxy as any;
            const id = root.$route.params.id;
            const { getUserSettings } = useUserSettings();
            const userSettings = ref<UserSettingsViewModel>();
            getUserSettings().then((value: UserSettingsViewModel) => {
                userSettings.value = value;
            });
            const { logItems } = useSensorHistory(id);
            const formatModifiedDate = (modifiedDate) => {
                return moment.utc(modifiedDate).tz(userSettings.value.timezone).format("MMM DD, YYYY HH:mm:ss");
            };
            const sensorId = parseInt(id);
            const sensorName = useDevice().getName(sensorId).toUpperCase();

            const goBack = () => {
                window.history.back();
            };

            return {
                logItems,
                sensorName,
                formatModifiedDate,
                goBack
            };
        }
    });
</script>
<style lang="scss" scoped>
    .theme--light.v-timeline:before {
        background: white;
        top: 40px;
    }

    .theme--light.v-timeline-item {
        align-items: center;
    }

    .transparent-line::v-deep.v-timeline:before {
        background: transparent !important;
    }
</style>